import { render, staticRenderFns } from "./AddFcReceivingAgent.vue?vue&type=template&id=f4a6101a"
import script from "./AddFcReceivingAgent.vue?vue&type=script&lang=js"
export * from "./AddFcReceivingAgent.vue?vue&type=script&lang=js"
import style0 from "./AddFcReceivingAgent.vue?vue&type=style&index=0&id=f4a6101a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports